import { SettingEventsEnum } from '@carboncopyco/types/desktop/appSettings';
import { useEffect } from 'react';
import { AppEventsEnum } from '../../../../shared/enums/AppEventsEnum';
import { APP_MODAL_Z_INDEX } from '../../../constants';
import GoToAssetModal from '../../../modals/GoToAssetModal/GoToAssetModal';
import SettingsAppModal from '../../../modals/SettingsAppModal/SettingsAppModal';
import ModalWrapper from '../ModalWrapper';
import { ModalType, useModals } from '../useModals';

const ProtectedAppModals = () => {
  const {
    handleSetModalType,
    modalType,
    closeModal,
    modalRef,
    modalActions,
    modalConfigByType,
  } = useModals();

  const showSettingsModal = () => {
    handleSetModalType(ModalType.APP_SETTINGS);
  };

  const initEventListeners = () => {
    window.dsDesktop?.ipcRenderer.on(
      SettingEventsEnum.MAIN_TO_APP_VIEW_SHOW_SETTINGS_MODAL,
      showSettingsModal
    );

    window.dsDesktop?.ipcRenderer.on(
      AppEventsEnum.MAIN_TO_RENDERER_OPEN_GO_TO_MODAL,
      () => {
        handleSetModalType(ModalType.GO_TO_ASSET);
      }
    );
  };

  useEffect(() => {
    initEventListeners();
  }, []);

  const getModalData = () => {
    switch (modalType) {
      case ModalType.APP_SETTINGS:
        return (
          <SettingsAppModal
            divRef={modalRef}
            onCloseModal={closeModal}
          />
        );
      case ModalType.GO_TO_ASSET:
        return (
          <GoToAssetModal
            divRef={modalRef}
            onCloseModal={closeModal}
          />
        );
      default:
        return null;
    }
  };

  if (!modalType) return null;

  const {
    locked,
    noBackground,
    removeCloseIcon,
    containerClass,
    isCenterPosition,
  } = modalConfigByType;
  return (
    <ModalWrapper
      locked={locked}
      isVisible={!!modalActions?.isModalOpen()}
      isCenterPosition={isCenterPosition}
      noBackground={noBackground}
      removeCloseIcon={removeCloseIcon}
      containerClass={containerClass}
      zIndex={APP_MODAL_Z_INDEX}
    >
      {getModalData()}
    </ModalWrapper>
  );
};

export default ProtectedAppModals;
